import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 200 200",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("linearGradient", {
  fill: "currentColor",
  id: "a",
  gradientUnits: "userSpaceOnUse",
  x1: "100",
  y1: "617.455",
  x2: "100",
  y2: "757.1",
  gradientTransform: "translate(0 -567)"
}, [
  /*#__PURE__*/_createElementVNode("stop", {
    fill: "currentColor",
    offset: "0"
  }),
  /*#__PURE__*/_createElementVNode("stop", {
    fill: "currentColor",
    offset: "1"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M98 10c25.8 0 46.7 20.1 46.7 45s-20.9 45-46.7 45-46.7-20.2-46.7-45c0-24.9 20.9-45 46.7-45zm0 0c25.8 0 46.7 20.1 46.7 45s-20.9 45-46.7 45-46.7-20.2-46.7-45c0-24.9 20.9-45 46.7-45zM80.5 115.1h38.9c33.3 0 60.3 26 60.3 58.1v3.7c0 12.7-27 13.1-60.3 13.1H80.5c-33.3 0-60.3 0-60.3-13.1v-3.7c0-32.1 27-58.1 60.3-58.1z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: "tri-icon",
    style: _normalizeStyle(`font-size: ${_ctx.size}; color: ${_ctx.color}; width: 1em; height: 1em; display:block; line-height: 0;`)
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
  ], 4))
}